// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import createRoutes from '../routing';
import { Router } from 'react-router';
import { trackPageView } from '../utils/analytics';
import { trackDsaAssessmentNavigation } from '../utils/dsaRouteAnalytics';


export default class Root extends Component {
  render() {
    const { store, history } = this.props;

    function logPageView() {
      let state = store.getState();
      let hash = null;
      if (state.user) {
        hash = state.user.hash;
      }
      const uri = window.location.pathname + window.location.search;
      trackPageView({
        page_path: uri,
        page_title: typeof document !== 'undefined' ? document.title : '',
        tool: 'dsa',
        user_id: hash || undefined
      });
      const assessmentType = state.dsa && state.dsa.dsa && state.dsa.dsa.dsaType;
      trackDsaAssessmentNavigation(window.location.pathname, assessmentType);
    }

    return (
      <Provider store={store}>
        <IntlProvider locale='en'>
          {/* eslint-disable-next-line react/jsx-no-bind */}
          <Router history={history} routes={createRoutes(store)} onUpdate={logPageView} />
        </IntlProvider>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Root.js